// @core/api/endpoints/team/approve_team_role_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApproveTeamRoleApplicationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Approve role application
 * Approves a pending role change application. The member's role is updated to the requested role.
 */
export async function ApproveTeamRoleApplication(
  team_id: string,
  request_id: string,
  data: ApproveTeamRoleApplicationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/role-applications/:request_id/approve`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
